document.addEventListener('DOMContentLoaded', function () {
  var productEl = document.querySelector('.product.has-architect-overlay');
  if (!productEl) return;

  var observer = new MutationObserver(function () {
    document.querySelectorAll('.pswp__item').forEach(function (item) {
      item.classList.add('has-architect-banner');
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});